<template>
    <article>
        <div class="con" id="articleMain">
            <div class="author-container" v-if="articleInfo.author">
                <img class="author-avatar" :src="articleInfo.author && articleInfo.author.avatar" alt="">
                <div class="author-name">{{ articleInfo.author && articleInfo.author.name }}</div>
            </div>
            <div v-html='articleInfo.text' v-if='articleInfo.text' class="article-content"></div>
            <div class="img-wrap"
                 v-if="isHaveMedia && isHaveMedia.media && isHaveMedia.media.photo && isHaveMedia.media.photo.length">
                <div class="img-container"
                     v-for="item in isHaveMedia.media.photo"
                     :key="item.original.url">
                    <img class="article-img" :src="item.original.url">
                </div>
            </div>
            <div class="video-wrap"
                 v-if="isHaveMedia && isHaveMedia.media &&  isHaveMedia.media.video">
                <!--播放区-->
                <section class="video" v-if="checkMode(isHaveMedia && isHaveMedia.media && isHaveMedia.media.video)">
                    <video
                        :style="'background:url('+ isHaveMedia && isHaveMedia.media && isHaveMedia.media.video.cover +') top center no-repeat rgba(0,0,0,0.7);background-size: cover;height:'+ video_height + 'px'"
                        :src="isHaveMedia && isHaveMedia.media && isHaveMedia.media.video.url" controls="controls"
                        @play="videoPlay()"></video>
                </section>
                <div v-else>
                    <div class="mask"></div>
                    <div class="media-container media-container-video"
                         v-if="isHaveMedia && isHaveMedia.media && isHaveMedia.media.video.cover"
                         v-on:click="videoPlay(isHaveMedia && isHaveMedia.media && isHaveMedia.media.video.url)"
                         v-bind:style="{'backgroundImage':'url('+ isHaveMedia && isHaveMedia.media && isHaveMedia.media.video.cover +')','height':video_height+'px'}">
                        <div class="media-holder media-holder-video"></div>
                    </div>
                    <div class="media-container media-container-video" v-else
                         v-on:click="videoPlay(isHaveMedia && isHaveMedia.media && isHaveMedia.media.video.url)"
                         v-bind:style="{'height':video_height+'px'}"
                    >
                        <div class="media-holder media-holder-video"></div>
                    </div>
                </div>
            </div>
        </div>
    </article>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';

export default {
    name: 'tweetArticleCon',
    data: function () {
        return {
            baseUrl: global.apiDomain,
            imgMode: 'loading',
            con: [],
            video_height: 0,
            UUID: '',
            isHaveMedia: this.articleInfo.entities
        };
    },
    props: ['articleInfo'],
    created: function () {
    },
    mounted () {
        let mainWidth = (document.documentElement.clientWidth || window.screen.width);
        this.video_height = (mainWidth - 30) * 9 / 16 - 40;
    },
    methods: {
        // 判断当前播放的类型是否是player
        checkMode (item) {
            let android_mode = item.android_mode;
            let ios_mode = item.ios_mode;
            if (android_mode == 'player') {return true;}
            if (ios_mode == 'player') {return true;}
            return false;
        },
        videoPlay: function (url) {
            if (url) {
                location.href = url;
            }
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
    .con {
        margin: auto 12px;
    }

    article video {
        display: block;
        width: 100%;
        margin: 0;
        background: #3e3e3e no-repeat center center;
        background-size: 118px;
        border-radius: 1px;
        -moz-border-radius: 1px;
        -webkit-border-radius: 1px;
    }

    article a {
        color: #399e5c;
    }

    .media-container {
        display: block;
        position: relative;
        z-index: 1000;
        margin: 0 auto;
    }

    .img-wrap {
        margin: 10px auto;
        overflow: hidden;
        .img-container {
            width: 100%;
            float: left;
            overflow: hidden;
            position: relative;
            margin-bottom: 10px;
            img {
               width: 100%;
            }
        }
    }

    .media-loader {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 999;
        width: 100%;
        height: 100%;
        background: url(../assets/loading_circle.gif) #e9e9e9 no-repeat center center;
        opacity: .3;
        -webkit-opacity: .3;
        -moz-opacity: .3;
        background-size: 20px 20px;
    }

    .media-holder {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 999;
        width: 100%;
        height: 100%;
        background: url(../assets/play@80x80.png) no-repeat center center;
        background-size: 40px 40px;
    }

    .media-label {
        position: absolute;
        top: 0;
        left: 0;
        background: url(../assets/gif.png) 0 0 no-repeat;
        width: 33px;
        height: 33px;
        background-size: 100% 100%;
        text-indent: 1000px;
    }

    .media-loading {
        background: url(../assets/loading_circle.gif) #e9e9e9 no-repeat center center;
        filter: alpha(opacity=30);
        opacity: 0.3;
        background-size: 20px 20px;
    }

    .img-off-holder {
        width: 100%;
        height: auto;
        text-align: center;
        display: table-cell;
        vertical-align: middle;
    }

    article .video {
        position: relative
    }

    article .video .mask {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: url(../assets/icon_playing.png) center center no-repeat rgba(0, 0, 0, 0.5);
        background-size: auto 20px;
        z-index: 10000;
        display: none;
    }

    .media-container-video {
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        background-color: rgba(0, 0, 0, 0.5);
        border-bottom: 20px solid #000000;
        border-top: 20px solid #000000;
        width: 100%;
        background-image: url(https://allfootball-static.dongqiudi.com/web-new/static/api/images/video_off_holder.png);
    }

    .media-holder-video {
        background: url(https://allfootball-static.dongqiudi.com/web-new/static/api/images/video_play.png) no-repeat center center;
        background-size: 48px auto;
    }

    .fade-enter-active {
        transition: opacity 1.5s
    }

    .fade-enter {
        opacity: 0
    }

    a.product_box:visited {
        color: #333333;
    }

    .audio {
        background-color: #ffffff;
        overflow: hidden;
        padding: 4px;
        position: relative;;
        margin: 24px auto;
        border: 1px solid #e9e9e9;
        height: 40px;
    }

    .audio a {
        width: 40px;
        height: 40px;
        float: right;
        margin-top: -43px;

    }

    .audio a.play {
        background: url(../assets/icon_play.png) center center no-repeat;
        background-size: 12px
    }

    .audio a.pause {
        background: url(../assets/icon_pause.png) center center no-repeat;
        background-size: 12px
    }

    .audio .main {
        padding-left: 50px;
        background: url(../assets/bg_music.png) 0 0 no-repeat;
        background-size: 40px 40px;
    }

    .audio .main h3 {
        height: 24px;
        line-height: 24px;
        font-size: 14px;
        color: #2d2f32;
        font-weight: 400;
        margin: 0;
        padding: 0;
    }

    .audio .main p {
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        color: #8c9399;
        margin: 0;
        padding: 0;
    }

    .audio .progress {
        position: absolute;
        height: 2px;
        bottom: 0;
        left: 0;
        z-index: 100;
        background: #55c818;
    }

    .audio audio {
        position: absolute;
        display: none;
    }

    .tips {
        margin-top: -20px;
        display: block;
        width: 100%;
        font-size: 0.8em;
        color: #888888;
        line-height: 1.5
    }

    .tips_v {
        display: block;
        width: 100%;
        font-size: 0.8em;
        color: #8c9399;
        line-height: 1.5
    }

    .author-container {
        padding-top: 10px;
        padding-bottom: 5px;
        overflow: hidden;
        .author-name {
            font-size: 1rem;
            font-family: SFUIDisplay-Bold;
            font-weight: bold;
            color: #2D2F32;
            float: left;
            margin-left: 12px;
            padding-top: 6px;
        }
        .author-avatar {
            width: 45px;
            height: 45px;
            border-radius: 50%;
            float: left;
            margin: 0;
        }
    }

    .article-content {
        font-size: 1rem;
        font-family: SFUIDisplay-Regular;
        font-weight: 400;
        color: #2D2F32;
        line-height: 22px;
        margin-top: 5px;
    }
</style>



// WEBPACK FOOTER //
// tweetCon.vue?17be283e